import Vue from 'vue'
import Vuex from 'vuex'
import {
  getUserInfo
} from '@/api/login'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    isLoggedIn: !!localStorage.getItem('token'),
    userInfo: null,
    isInPersonalCenter: false
  },
  getters: {},
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      state.isLoggedIn = !!token
      if (token) {
        localStorage.setItem('token', token)
      } else {
        localStorage.removeItem('token')
      }
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_PERSONAL_CENTER_MODE(state, isInPersonalCenter) {
      state.isInPersonalCenter = isInPersonalCenter
    }
  },
  actions: {
    setToken({
      commit
    }, token) {
      commit('SET_TOKEN', token)
    },
    async fetchUserInfo({
      commit
    }) {
      try {
        const res = await getUserInfo()
        if (res.code === 200) {
          commit('SET_USER_INFO', res.data)
        } else {
          commit('SET_TOKEN', '')
          commit('SET_USER_INFO', null)
        }
      } catch (error) {
        commit('SET_TOKEN', '')
        commit('SET_USER_INFO', null)
      }
    },
    logout({
      commit
    }) {
      commit('SET_TOKEN', '')
      commit('SET_USER_INFO', null)
      commit('SET_PERSONAL_CENTER_MODE', false)
    },
    setPersonalCenterMode({
      commit
    }, mode) {
      commit('SET_PERSONAL_CENTER_MODE', mode)
    }
  },
  modules: {}
})